// src/pages/stylist/EditProfilePage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowBackIcon } from '../../components/common/Icons';
import StoreDownloadCta from '../../components/common/StoreDownloadCta';
import '../../styles/EditProfilePage.css';

const EditProfilePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="edit-profile-page">
      <div className="edit-profile-header">
        <button className="edit-profile-back" onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </button>
        <h1 className="edit-profile-title">Edit Profile</h1>
        <div style={{ width: 80 }} />
      </div>

      <div className="edit-profile-app-only">
        <div className="edit-profile-app-only-icon">📱</div>
        <h2 className="edit-profile-app-only-title">Use the App to Edit Your Profile</h2>
        <p className="edit-profile-app-only-message">
          For the best experience, profile editing is only available in the LookBel mobile app.
        </p>
        <div className="edit-profile-store-actions">
          <StoreDownloadCta store="ios" variant="profile" />
          <StoreDownloadCta store="android" variant="profile" />
        </div>
        <button
          className="edit-profile-app-only-back"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default EditProfilePage;
